import React from "react";
import { Link } from "react-router-dom";
import { mainBody, repos, about, experiences, getInTouch } from "../editable-stuff/config.js";
import ThemeToggle from "./ThemeToggle";

const Navigation = React.forwardRef((props, ref) => {
  return (
    <div className="floating-nav">
      <div className="container d-flex justify-content-between">
        <nav className="nav-pill" aria-label="Page links">
          <Link to="/" className="pill-btn" aria-label="Home">
            <i className="fas fa-home" />
          </Link>
          {(repos.show || experiences.show) && (
            <Link to="/work" className="pill-btn" aria-label="Work">
              <i className="fas fa-briefcase" />
            </Link>
          )}
          {about.show && (
            <Link to="/about" className="pill-btn" aria-label="About">
              <i className="fas fa-user" />
            </Link>
          )}
          {getInTouch.show && (
            <a href={`mailto:${getInTouch.email}`} className="pill-btn" aria-label="Contact">
              <i className="fas fa-envelope" />
            </a>
          )}
        </nav>

        <nav className="nav-pill" aria-label="Theme and social links">
          <ThemeToggle />
          {mainBody.icons.map((icon, index) => (
            <a
              key={`nav-social-${index}`}
              className="pill-btn"
              target="_blank"
              rel="noopener noreferrer"
              href={icon.url}
              aria-label={`My ${icon.image.split("-")[1]}`}
            >
              <i className={`fab ${icon.image}`} />
            </a>
          ))}
        </nav>
      </div>
    </div>
  );
});

export default Navigation;
